function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M2.95397 17.63L2.80845 17.0479L2.95397 17.63L6.60809 16.7164C6.62428 16.7124 6.64044 16.7084 6.65654 16.7044C6.87531 16.65 7.08562 16.5978 7.27707 16.4894C7.46852 16.381 7.62153 16.2275 7.7807 16.0679C7.79242 16.0561 7.80417 16.0444 7.81598 16.0326L17.2601 6.58848L17.2601 6.58847L17.2835 6.56498L17.2869 6.56166C17.5972 6.25137 17.8715 5.97715 18.0628 5.72638C18.2702 5.45457 18.4358 5.14104 18.4358 4.75C18.4358 4.35896 18.2702 4.04543 18.0628 3.77361C17.8715 3.52285 17.5972 3.24864 17.2869 2.93835L17.26 2.91152L16.3385 1.98995L16.3117 1.96314C16.0014 1.6528 15.7272 1.37853 15.4764 1.1872C15.2046 0.979813 14.891 0.814214 14.5 0.814214C14.109 0.814214 13.7954 0.979813 13.5236 1.1872C13.2729 1.37853 12.9986 1.65278 12.6884 1.96311L12.6615 1.98995L3.21745 11.434C3.20565 11.4458 3.19386 11.4576 3.18211 11.4693C3.02249 11.6285 2.86904 11.7815 2.76064 11.9729C2.65225 12.1644 2.59999 12.3747 2.54562 12.5935C2.54162 12.6096 2.53761 12.6257 2.53356 12.6419L1.62003 16.296C1.61762 16.3057 1.61518 16.3154 1.61272 16.3252C1.57411 16.4793 1.53044 16.6535 1.51593 16.8018C1.49978 16.9669 1.50127 17.2662 1.74255 17.5074L2.14257 17.1074L1.74255 17.5075C1.98384 17.7487 2.28307 17.7502 2.4482 17.7341C2.59647 17.7196 2.77075 17.6759 2.92483 17.6373C2.93463 17.6348 2.94435 17.6324 2.95397 17.63Z",
  stroke: "black",
  strokeWidth: 1.2
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M11.375 2.875L16.375 7.875",
  stroke: "black",
  strokeWidth: 1.2
});

function SvgEdit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.eb205233.svg";
export { ForwardRef as ReactComponent };